import React from 'react';

export default () => {
  return <script src="https://cdn.jsdelivr.net/algoliasearch/3/algoliasearch.min.js" />;
};



// WEBPACK FOOTER //
// ./components/app-shell/algolia.js